import SchedulingNotes from './SchedulingNotes';

export default SchedulingNotes;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/Scheduling/Notes/index.js